module.exports = __webpack_public_path__ + "img/sidebar-header-logo.ac82df5d.svg";